import { useSyncExternalStore } from 'react';

let isBusyModeBannerHidden = false;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => isBusyModeBannerHidden;

export const setPowerDialerBusyModeBannerHidden = (next: boolean) => {
  if (isBusyModeBannerHidden === next) {
    return;
  }
  isBusyModeBannerHidden = next;
  for (const listener of listeners) {
    listener();
  }
};

export const usePowerDialerBusyModeBannerHidden = () =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
